import * as React from 'react'

export const SVG_Forward = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 10 15">
        <path
            fill="#4F5B68"
            fillRule="evenodd"
            d="M9.875 7.388a.676.676 0 0 0-.26-.52L1.26.34a.74.74 0 0 0-1.01.1.673.673 0 0 0 .104.97l7.81 6.102-7.778 6.076a.674.674 0 0 0-.104.97.741.741 0 0 0 1.01.1l8.353-6.526a.674.674 0 0 0 .229-.745"
        />
    </svg>
)
